import { useQuery } from '@tanstack/react-query';
import { unavailabilityDayOptions } from '../../constants/unavailabilityDays';
export function useUnavailabilityDays(filter, scope) {
    const { data, isLoading, isSuccess } = useQuery({
        ...unavailabilityDayOptions.get(filter, scope),
        enabled: !!filter?.parkingId,
    });
    return {
        unavailabilityDays: data ?? [],
        loadingUnavailabilityDays: isLoading,
        isSuccess,
    };
}
